import { useSelector } from 'react-redux';
import { UseAccessParams } from "shared/types/UseAccessParams";
import { checkAccess } from "./checkAccess";


export const useAccess = ({ environment, permission, licence, role, shopPermissions }: UseAccessParams) => {
  const auth = useSelector((state: any) => state.auth);
  return checkAccess({ environment, permission, licence, role, shopPermissions, auth })
};
